import { Table } from 'foundations-components/transitional/components/Table';
import { TAG_MANAGER_TABLE_COLUMNS } from '../constants/manageTags';
import TagManagerTableHeader from '../components/reportsTable/tagManager/TagManagerTableHeader';
import { NavMarker } from 'react-rhumb';
import TagManagerTableRow from '../components/reportsTable/tagManager/TagManagerTableRow';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { selectTags, selectTagsStatus } from '../redux/tags';
import { useSelector } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Alert } from 'foundations-components/transitional/components/Alert';
import requestStatusType from '../constants/requestStatusTypes';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TagManagerTable = () => {
  const tags = useSelector(selectTags);
  const status = useSelector(selectTagsStatus);
  const numColumns = TAG_MANAGER_TABLE_COLUMNS.length;
  const {
    SUCCEEDED,
    FAILED,
    UNINITIALIZED,
    PENDING
  } = requestStatusType;
  const TableColGroup = /*#__PURE__*/_jsx("colgroup", {
    children: TAG_MANAGER_TABLE_COLUMNS.map(column => /*#__PURE__*/_jsx("col", {
      style: {
        width: column.width
      }
    }, column.key))
  });
  const TableBodyEmpty = /*#__PURE__*/_jsx(NavMarker, {
    name: "TAG_MANAGER_TABLE_CONTAINER_EMPTY",
    children: /*#__PURE__*/_jsx("tbody", {
      children: /*#__PURE__*/_jsx("tr", {
        children: /*#__PURE__*/_jsx("td", {
          colSpan: numColumns,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "reports.tagManager.table.empty"
          })
        })
      })
    })
  });
  const TableBodyLoading = /*#__PURE__*/_jsx("tbody", {
    children: /*#__PURE__*/_jsx("tr", {
      children: /*#__PURE__*/_jsx("td", {
        colSpan: numColumns,
        children: /*#__PURE__*/_jsx(LoadingSpinner, {
          "data-test-id": "tag-manager-table-loader",
          grow: true
        })
      })
    })
  });
  const TableBodySuccess = /*#__PURE__*/_jsx(NavMarker, {
    name: "TAG_MANAGER_TABLE_CONTAINER",
    children: /*#__PURE__*/_jsx("tbody", {
      children: tags.map(tag => /*#__PURE__*/_jsx(TagManagerTableRow, {
        tag: tag
      }, tag.get('id')))
    })
  });
  const TableBodyFailure = /*#__PURE__*/_jsx(NavMarker, {
    name: "TAG_MANAGER_TABLE_CONTAINER_FAILURE",
    children: /*#__PURE__*/_jsx("tbody", {
      children: /*#__PURE__*/_jsx("tr", {
        children: /*#__PURE__*/_jsx("td", {
          colSpan: numColumns,
          children: /*#__PURE__*/_jsx(Alert, {
            type: "danger",
            titleText: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "reports.table.failedToLoad.title"
            }),
            closeable: false,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "reports.table.failedToLoad.description"
            })
          })
        })
      })
    })
  });
  const TableBody = (() => {
    if (status === UNINITIALIZED || status === PENDING) {
      return TableBodyLoading;
    } else if (status === FAILED) {
      return TableBodyFailure;
    } else if (status === SUCCEEDED && tags.size === 0) {
      return TableBodyEmpty;
    }
    return TableBodySuccess;
  })();
  return /*#__PURE__*/_jsxs(Table, {
    condensed: true,
    tableLayout: "fixed",
    children: [TableColGroup, /*#__PURE__*/_jsx(TagManagerTableHeader, {}), TableBody]
  });
};
export default TagManagerTable;